import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import logo from './miotly-removebg-preview.png';
import './App.css';
import Maintenance from "./components/Maintenance";
import Login from "./components/Login";
import Register from "./components/Register";
import AdminPanel from "./components/AdminPanel";
import UserPanel from "./components/UserPanel";

const environment = process.env.REACT_APP_ENVIRONMENT_NAME || 'not defined environment';
console.log('App Environment:', process.env.REACT_APP_ENVIRONMENT_NAME);
console.log('Version:', process.env.REACT_APP_VERSION + "." + process.env.REACT_APP_GIT_HASH);

const App = () => {
  useEffect(() => {
    document.title = "Miotłoch";
  }, []);

  return (
    <Router>
      <Routes>
        {/* Obecna strona jako Maintenance */}
        <Route path="/" element={<Maintenance logo={logo} environment={environment} />} />
        
        {/* Logowanie i rejestracja */}
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />

        {/* Panel administratora i użytkownika */}
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/user" element={<UserPanel />} />

        {/* Obsługa 404 */}
        <Route path="*" element={<div>404 Not Found</div>} />
      </Routes>
    </Router>
  );
};

export default App;
